export default {"src":"/_next/static/media/visa.8bdb4fd4.svg","height":50,"width":50};